import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CenteredContent from '../../../components/CenteredContent/CenteredContent';
import Screen from '../../../components/Screen/Screen';
import { getContentfulEntryByIdOrSlug } from '../../../lib/contentful/getContentfulContent';
import { getArticleDetails } from '../helpers/getArticleDetails';
import { getRecipeDetails } from '../helpers/getRecipeDetails';
import { getVideoDetails } from '../helpers/getVideoDetails';
import { BackToLearningCenterLink } from './BackToLearningCenterLink';

export function DetailView(props) {
  const { type, slug } = props;
  const [content, setContent] = useState(null);

  useEffect(() => {
    getContentfulEntryByIdOrSlug(slug, type).then(setContent).catch(setContent);
  }, [slug]);

  let Body = null;
  let title = null;

  if (content === null) {
    Body = () => (
      <CenteredContent>
        <CircularProgress color="primary" />
      </CenteredContent>
    );
    title = 'Loading...';
  } else if (content instanceof Error) {
    Body = () => <Typography variant="h5">There was an issue.</Typography>;
    title = 'Error';
  } else if (type === 'video') {
    const videoDetails = getVideoDetails(content);
    Body = videoDetails.Body;
    title = videoDetails.title;
  } else if (type === 'recipe') {
    const recipeDetails = getRecipeDetails(content);
    Body = recipeDetails.Body;
    title = recipeDetails.title;
  } else if (type === 'article') {
    const articleDetails = getArticleDetails(content);
    Body = articleDetails.Body;
    title = articleDetails.title;
  }

  const typeToSubcategory = {
    video: 'videos',
    recipe: 'recipes',
    article: 'articles',
  };
  return (
    <>
      {props.type === 'video' ? <script src="https://player.vimeo.com/api/player.js"></script> : <></>}

      <Screen
        title={title}
        showSidebarNav
        admin
      >
        <Box sx={{ padding: '30px' }}>
          <Grid
            alignSelf="flex-start"
            marginBottom="10px"
          >
            <BackToLearningCenterLink subcategory={typeToSubcategory[type]} />
          </Grid>

          <Grid
            direction="column"
            height="100%"
            container
            spacing={2}
          >
            <Body />
          </Grid>
        </Box>
      </Screen>
    </>
  );
}
